<template>
    <div class="gains-structure ba-w-100">
        <div class='ba-card-breadcrumb ba-card'>
          <nav class='ba-breadcrumb'>
            <ol class='ba-breadcrumb-ol'>
              <li class='ba-breadcrumb-item ba-main-item'>
                <a href='#'>
                  <builderall-icon code='house' />
                </a>
              </li>
              <li class='ba-breadcrumb-item'>
                <a href='#'>{{t.label_concession_gains}}</a>
              </li>
            </ol>
          </nav>
        </div>

        <div class="tabset ba-box-tabs ba-w-100 ba-card">

            <!-- Tab 1 -->

            <input type="radio" name="tabset" id="tab1" aria-controls="tab1" checked class="hidden"/>
            <label for="tab1" class="ba-tab">{{t.earnings}}</label>
            <!-- Tab 2 -->
            <input
                type="radio"
                name="tabset"
                id="tab2"
                aria-controls="tab2"
                @click="getCompletedGains()"
                class="hidden"
            />
            <label for="tab2" class="ba-tab">{{t.Completed}}</label>

            <hr class='ba-hr-row'>

            <div class="tab-panels">
                <section id="tab1" class="tab-panel ba-w-100">
                    <div>
                        <label for>Periodo:</label>
                        <select
                            class="ba-select ba-md"
                            @change="handleTablePeriod()"
                            ref="selectPeriod"
                        >
                            <option selected value="initial">Atual</option>
                            <option
                                v-for="(item, index) in this.allPeriods"
                                :key="index"
                                :value="item.period"
                            >{{brDate(item.initial_date) + ' - ' + brDate(item.final_date)}}</option>
                        </select>
                    </div>
                    <div class="loading" v-if="loadingOne"></div>
                    <div class="table__scroll" v-if="!loadingOne">
                        <table class="ba-table ba-md">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>{{t.label_usuario}}</th>
                                    <!-- <th>Data de PGT</th> -->
                                    <!-- <th>{{t.franchise_home_plans}}</th> -->
                                    <th>{{t.label_sell_value}}</th>
                                    <th>Valor Líquido</th>
                                    <th>{{t.label_emb_direto}}</th>
                                    <th>{{t.label_emb_direto_2}}</th>
                                    <th>{{t.affiliates}} 1</th>
                                    <th>{{t.affiliates}} 2</th>
                                    <th>{{t.label_affilaite_free}}</th>
                                    <th>{{t.label_total}}</th>
                                    <th>{{t.label_operation_cost}}</th>
                                    <th>{{t.label_to_receive}}</th>
                                    <th>{{t.ad_anuncios_ad_status_pago}}</th>
                                    <!-- <th>{{t.label_refund}}</th> -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                  v-for="(item, index) in this.paginatedData"
                                  :key="index"
                                  :class="handleClassLine(item)"
                                >
                                  <td>{{item.id}}</td>
                                  <td>
                                    {{item.userName}}
                                    <br />
                                    {{item.userEmail.substring(0,3) + '**@*****.***'}}
                                    <br />
                                    <br />
                                    <span class="js-span-created display-block">
                                            {{item.refundedAt ? handleDate(item.refundedAt) : handleDate(item.createdAt)}}<br />
                                        </span>
                                    <span class="js-span-refunded display-none">
                                            {{handleDate(item.refundedAt)}}
                                        </span>
                                  </td>
                                  <!-- <td>{{brDate(item.createdAt)}}</td> -->
                                  <!-- <td>{{item.planName}}</td> -->
                                  <td>R$ {{round(item.planValue)}}</td>
                                     <td>R$ {{round((item.planValue * fee(item)))}}</td>

                                  <!-- amb direto -->
                                  <td>
                                    <div v-if="item.commissions['ambassador'] && item.commissions['ambassador'].length >= 1">
                                            <span
                                              v-if="(isAmbassador0(item.commissions['ambassador'][0].type) || item.commissions['ambassador'][0].type == 'AMBASSADOR_PLAN')"
                                            >R$ {{round(item.commissions['ambassador'][0].value)}}</span>
                                      <span v-else>
                                                <span>-</span>
                                            </span>
                                    </div>
                                    <div v-else>-</div>
                                  </td>
                                  <!-- //amb direto -->

                                  <!-- amb2 -->
                                  <td>
                                    <div v-if="item.commissions['ambassador'] && item.commissions['ambassador'].length >= 2">
                                            <span
                                              v-if="isAmbassadorOneOrMore(item.commissions['ambassador'][1].type)"
                                            >R$ {{round(item.commissions['ambassador'][1].value)}}</span>
                                      <span v-else>
                                                <div>-</div>
                                            </span>
                                    </div>
                                    <div v-else>-</div>
                                  </td>
                                  <!-- //amb2 -->

                                  <!-- aff1 -->
                                  <td>
                                    <div v-if="item.commissions['affiliates'] && item.commissions['affiliates'].length >= 1">
                                            <span
                                              v-if="(isAffiliate0(item.commissions['affiliates'][0].type))"
                                            >R$ {{round(item.commissions['affiliates'][0].value)}}</span>
                                      <span v-else>-</span>
                                    </div>
                                    <div v-else>-</div>
                                  </td>
                                  <!-- //aff1 -->

                                  <!-- aff2 -->
                                  <td>
                                    <div v-if="item.commissions['affiliates'] && item.commissions['affiliates'].length >= 2">
                                            <span
                                              v-if="item.commissions['affiliates'][1].value != 0"
                                            >R$ {{round(item.commissions['affiliates'][1].value)}}</span>
                                      <div v-else>-</div>
                                    </div>
                                    <div v-else>-</div>
                                  </td>
                                  <!-- //aff2 -->

                                  <td>
                                    <div v-if="item.commissions['builder_plan'] && item.commissions['builder_plan'].length >= 1">
                                      <div
                                        v-for="(itemSub, indexSub) in item.commissions['builder_plan']"
                                        :key="indexSub"
                                      >
                                        <span>R$ {{round(itemSub.value)}}</span>
                                      </div>
                                    </div>
                                    <div v-else>-</div>
                                  </td>
                                  <!-- TOTAL -->
                                  <td>R$ {{round(item.value)}}</td>
                                  <!-- Custo da Operação -->
                                  <td>R$ {{round(((item.planValue * fee(item)) * percentDiscount))}}</td>
                                  <!-- A receber -->
                                  <td>R$ {{sanitizeNegativeValue(round(item.value - ((item.planValue * fee(item)) * percentDiscount)))}}</td>
                                  <td>
                                    <span v-if="item.paid == 'NAO'">NÃO</span>
                                    <span v-else style="color:#0cad25;">SIM</span>
                                  </td>
                                </tr>
                            </tbody>
                        </table>
                      <div class="bottom-paginator">
                        <fs5-button
                          class="paginator-button"
                          :label="view.translation['label-prev']"
                          :btn-type="'primary'"
                          :text-transform-type="'uppercase'"
                          :disabled="disablePrev"
                          @clicked="disablePrev ? '' : prevPage()"
                        ></fs5-button>
                        <fs5-button
                          class="paginator-button"
                          :label="view.translation['next']"
                          :btn-type="'primary'"
                          :text-transform-type="'uppercase'"
                          :disabled="disableNext"
                          @clicked="disableNext ? '' : nextPage()"
                        ></fs5-button>
                      </div>
                    </div>
                    <div class="values" v-if="!loadingOne">
                        <div class="value__only">
                            <span>R$</span>
                            <span>{{round(total)}}</span>
                        </div>
                        <span>{{t.label_total_receive}}</span>
                    </div>
                </section>

                <section id="tab2" class="tab-panel ba-w-100">

                    <div class="loading" v-if="loading"></div>
                    <div class="table__scroll ba-w-100" v-if="!loading">
                        <table class="ba-table ba-md ba-w-100">
                            <thead>
                                <tr>
                                    <th>Período</th>
                                    <th>Total Parcial</th>
                                    <th>Desconto</th>
                                    <th>Crédito</th>
                                    <th>Reembolsos</th>
                                    <th>Resultado</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="(item, index) in completed_gains_computed" :key="index">
                                    <td>{{item.periodo}}</td>
                                    <td>{{item.total_commissions}}</td>
                                    <td>{{item.descontos}}</td>
                                    <td>{{item.credito}}</td>
                                    <td class="text-red">{{item.reembolso}}</td>
                                    <td
                                        class="text-red"
                                        v-if="item.resultado < 0"
                                    >{{item.resultado}} {{t.label__gains_payed}}</td>
                                    <td
                                        class="text-green"
                                        v-if="item.resultado > 0"
                                    >{{item.resultado}} {{t.label__gains_received}}</td>
                                    <td v-if="item.resultado == 0">{{item.resultado}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
const BASE_URL = window.location.origin;
export default {
    name: "gains-franchisee-ba",
    props: ["view"],
    data() {
        return {
            t: this.view.translation,
            items: null,
            allData: null,
            total: 0,
            user_id: null,
            completed_gains_data: [],
            loadingOne: true,
            loading: true,
            allPeriods: null,
            selectPeriod: null,
            percentDiscount: 0.1,
            typeReq: null,

            pageNumber: 0,
            listData: null,
            size: 75,
            maxPage: null,
            typeAfterResponse: 'initial',
            disableNext: false,
            disablePrev: true
        };
    },
    computed: {
        completed_gains_computed: function() {
            return this.completed_gains_data;
        },
        paginatedData(){
          const start = this.pageNumber * this.size,
            end = start + this.size;
          return this.listData.slice(start, end);
        },
    },
    methods: {
        nextPage(){
          this.pageNumber < this.maxPage ? this.pageNumber++ : ''
        },
        prevPage(){
          this.pageNumber == 0 ? '' : this.pageNumber--
        },
        pageCount(){
          let l = this.listData.length,
            s = this.size;
          return Math.ceil(l/s);
        },
        getCompletedGains() {
            this.loading = true;
            var vm = this;
            axios
                .get(
                    `${BASE_URL}/br/office/franchise-system/franqueado-builderall-ganhos/get-ganhos-concluidos/${this.user_id}`
                )
                .then(res => {
                    vm.completed_gains_data = res.data.data;
                })
                .finally(() => (this.loading = false));
        },
        getPeriods() {
            this.loading = true;
            var vm = this;
            axios
                .get(
                    `${BASE_URL}/br/office/franchise-system/franqueado-builderall-ganhos/get-periods`
                )
                .then(res => {
                    vm.allPeriods = res.data;
                })
                .finally(() => (this.loading = false));
        },

        brDate(date) {
            let onlyDate = date.substring(0, 10);
            onlyDate = onlyDate
                .split("-")
                .reverse()
                .join("/");
            // let onlyTime = date.substring(11,16);
            // return onlyTime + ' - ' + onlyDate;
            return onlyDate;
        },
        isAffiliate0(item) {
            var re = /AFFILIATE\d_L0/g;
            if (item.match(re) != null) return true;
            return false;
        },
        isAffiliateOneOrMore(item) {
            var re = /AFFILIATE\d_L[123456789]/g;
            if (item.match(re) != null) return true;
            return false;
        },
        isAmbassador0(item) {
            var re = /AMBASSADOR_L0/g;
            if (item.match(re) != null) return true;
            return false;
        },
        isAmbassadorOneOrMore(item) {
            var re = /AMBASSADOR_L[123456789]/g;
            if (item.match(re) != null) return true;
            return false;
        },
        isAffiliateAnyType(item) {
            var re = /AFFILIATE/g;
            if (item.match(re) != null) return true;
            return false;
        },
        isAmbassadorAnyType(item) {
            var re = /AMBASSADOR/g;
            if (item.match(re) != null) return true;
            return false;
        },
        handleDate(date) {
            if(date == null) return;
            if (this.view.subsidirary_id == "2") {
                return this.brDate(date);
            } else {
                return this.usDate(date);
            }
        },
        usDate(date) {
            let onlyDate = date.substring(0, 10);
            let onlyTime = date.substring(11, 19);
            onlyDate = onlyDate.split("-");
            onlyDate = onlyDate[1] + "/" + onlyDate[2] + "/" + onlyDate[0];
            return onlyDate + ' ' + onlyTime;
        },
        brDate(date) {
            let onlyDate = date.substring(0, 10);
            let onlyTime = date.substring(11, 19);
            onlyDate = onlyDate
                .split("-")
                .reverse()
                .join("/");
            return onlyTime + ' ' + onlyDate;
        },
        handleTablePeriod() {
            this.handleDataTable(this.$refs.selectPeriod.value);
        },
        handleDataTable(type = "initial") {
            this.typeReq = type;
            //this.view.user.id == 85122  -- id teste prod welby
            // if((type == 'initial' || type != 'initial' && type >= 6) && this.view.user.id == 85122) {

            /**
             * [2024-02-26] Updated the percentage of operating costs {{percentDiscount}} from 15% to 40% in concession earnings
             * made by @CarlosRocha
             * requested by @GersonSoares
            */

            if (type == 'initial' || type >= 53) {
                this.percentDiscount = 0.4;
            }
            else if (type >= 6) {
                this.percentDiscount = 0.15;
            } else {
                this.percentDiscount = 0.1;
            }

            this.loadingOne = true;
            let vm = this;
            fetch(
                // 'https://bucket.services.builderall.com/franchises/earnings?paid=NAO',
                // `https://bucket.services.builderall.com/franchises/earnings?paid=${
                //     type == "initial" ? "NAO" : "SIM&period=" + type
                // }`,
                `${
                    window.__env.microservices.bucket.host
                }/franchises/earnings?paid=${
                    type == "initial" ? "NAO" : "SIM&period=" + type
                }`,
                {
                    mode: "cors",
                    headers: {
                        Origin: "*",
                        Authorization: "Bearer " + this.view.token
                        // Authorization: "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2MDYyNjk3NTksIlVzZXJJRCI6MjgxNjZ9.oRNA4cF8M_CHp5jzQHuNYMzf-xuTpHA0nLASumk9n0s"
                    }
                }
            )
                .then(res => {
                    return res.text();
                })
                .then(data => {
                    this.allResponse = JSON.parse(data);
                    vm.allData = this.allResponse;
                })
                .finally(() => {
                  this.afterResponse(type)
                });
        },
        afterResponse(type) {
          /**
           * Debugs
           * */
          console.time('tempoExecucao');

          let totalYears = 0;

          let totalRefunded = 0;
          if (type == "initial") {
            let newArrayAll = [];

            this.allData.map((commission, i) => {
              newArrayAll.push(commission);
            });
            newArrayAll.map((commission, i) => {
              if (commission.paid == "NAO" && commission.refundedAt == null) {
                totalYears += this.sanitizeNegativeValue(commission.value - ((commission.planValue * this.fee(commission)) * this.percentDiscount));

                if (commission.refunded == "SIM" && !commission.periodRefunded) {
                  totalRefunded += commission.value - ((commission.planValue * this.fee(commission)) * this.percentDiscount);
                }
              }
              if (commission.paid == "SIM" && commission.refundedAt != null && !commission.periodPaid && !commission.periodRefunded) {
                totalRefunded -= commission.value - ((commission.planValue * this.fee(commission)) * this.percentDiscount);
              }

              //para pegar os valores que virao duplicados do back
              if (commission.paid == "NAO" && !commission.periodPaid && !commission.periodRefunded && commission.refundedAt && Math.sign(commission.value) == -1) {
                totalRefunded += commission.value - ((commission.planValue * this.fee(commission)) * this.percentDiscount);
              }
            });

            this.allData = newArrayAll;
            this.paintItem();
          } else {
            this.allData.map(commission => {
              if (commission.paid === "SIM") {
                totalYears += this.sanitizeNegativeValue(commission.value - ((commission.planValue * this.fee(commission)) * this.percentDiscount));
                if (commission.refunded === "SIM" && commission.periodRefunded) {
                  totalRefunded += commission.value - ((commission.planValue * this.fee(commission)) * this.percentDiscount);
                }
              }
            });
          }

          this.total = totalYears - totalRefunded;

          for (let i = 0; i < this.allData.length; i++) {
            const element = this.allData[i];
            if (
              element.commissions &&
              element.commissions.length >= 1 &&
              element.commissions != []
            ) {
              let commissionNew = [];
              for (
                let j = 0;
                j < element.commissions.length;
                j++
              ) {
                const subElement = element.commissions[j];
                if (!this.allData[i].commissions["affiliates"])
                  this.allData[i].commissions[
                    "affiliates"
                    ] = [];
                if (!this.allData[i].commissions["ambassador"])
                  this.allData[i].commissions[
                    "ambassador"
                    ] = [];
                if (
                  !this.allData[i].commissions["builder_plan"]
                )
                  this.allData[i].commissions[
                    "builder_plan"
                    ] = [];
                if (this.isAffiliateAnyType(subElement.type)) {
                  this.allData[i].commissions[
                    "affiliates"
                    ].push(subElement);
                }
                if (this.isAmbassadorAnyType(subElement.type)) {
                  this.allData[i].commissions[
                    "ambassador"
                    ].push(subElement);
                }
                if (
                  subElement.type ==
                  "builderall-plano-builder-brl"
                ) {
                  this.allData[i].commissions[
                    "builder_plan"
                    ].push(subElement);
                }
              }
            }
          }
          this.listData = this.allData;
          this.loadingOne = false;

          /**
           * Debugs
           * */
          console.timeEnd('tempoExecucao');
        },
        paintItem() {
            setTimeout(() => {
                let items = document.querySelectorAll('.js-is-copy') || [];
                let i = 0;
                items.forEach(el => {
                    if(i % 2) {
                        el.classList.add('text-red');
                        el.children[1].children[3].classList.remove('display-block');
                        el.children[1].children[3].classList.add('display-none');
                        el.children[1].children[4].classList.remove('display-none');
                    }
                    i++;
                });
            }, 250);
        },
        handleClassLine(el) {
            // if(el.refundedAt != null && el.paid == 'SIM' && this.typeReq == 'initial') {
            //     return 'text-red';
            // }
            // if(el.isCopy) {
            //     return 'js-is-copy';
            // }
            // console.log('====================================');
            // console.log(el);
            // console.log('====================================');

            // <new>
            if(Math.sign(el.planValue) == -1 || (el.refundedAt != null && el.paid == 'SIM' && this.typeReq != 'initial')) {
                return 'text-red';
            }
            // </new>
        },
        fee({ planValue, createdAt }) {
            // percentuais aplicados a partir da data de corte 2021-05-20
            if (!moment('2021-05-20').isBefore(createdAt.split('T')[0])) {
                return 0.81;
            }
            if (planValue > 100) return 0.95;
			if (planValue > 50) return 0.94;
			return 0.93;
        },
        round(n = 0) {
            const sign = Math.sign(n);
            return (sign * Math.abs(Math.round(Math.abs(n * 100)) / 100)).toFixed(2);
        },
        sanitizeNegativeValue(value) {
          return value >= 0.00 ? value : 0.00;
        }
    },
    mounted() {
        this.getPeriods();
        this.handleDataTable();
        this.user_id = this.view.user.id;
    },
  watch: {
    listData(newVal, oldVal) {
      this.maxPage = Math.ceil(newVal.length / this.size)
    },
    pageNumber(newVal, oldVal) {
      if (this.pageNumber < this.maxPage) {
        this.disableNext = false
      } else {
        this.disableNext = true
      }
      if (this.pageNumber == 0) {
        this.disablePrev = true
      } else {
        this.disablePrev = false
      }
    }
  }
};
</script>
<style>
.business__layout__section {
    grid-template-columns: 185px calc(100% - 185px);
}
@media handheld, only screen and (max-width: 768px) {
    .business__layout__section {
        grid-template-columns: 100% !important;
    }
}
</style>
<style scoped lang="scss">
.gains-structure {
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: max-content;
  gap: 1rem;
}
.loading {
    border: 8px solid #d0e3f0;
    border-radius: 50%;
    border-top: 8px solid #0294ff;
    width: 50px;
    height: 50px;
    -webkit-animation: spin 1s linear infinite; /* Safari */
    animation: spin 1s linear infinite;
    margin: 0 auto;
    position: relative;
    margin: 1rem auto;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

/* Safari */
@-webkit-keyframes spin {
    0% {
        -webkit-transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(360deg);
    }
}

header {
    background: var(--theme-color-primary);
    border-radius: 0;
    width: 100%;
    padding: 0.7rem 2.5rem;
    margin: 0 auto;
    text-align: center;
    h3 {
        font-family: "Muli";
        font-size: 23px;
        color: #fff;
        margin: 0;
    }
}
.redTextRefund:nth-child(odd) {
    color: red !important;
}
.select__date {
    margin: 1rem 0;
    border: 1px solid #e7eaec;
    padding: 0.4rem;
}

.tabset .tab-panel {
    display: none;
}

.tabset > input:first-child:checked ~ .tab-panels > .tab-panel:first-child,
.tabset > input:nth-child(3):checked ~ .tab-panels > .tab-panel:nth-child(2),
.tabset > input:nth-child(5):checked ~ .tab-panels > .tab-panel:nth-child(3),
.tabset > input:nth-child(7):checked ~ .tab-panels > .tab-panel:nth-child(4),
.tabset > input:nth-child(9):checked ~ .tab-panels > .tab-panel:nth-child(5),
.tabset > input:nth-child(11):checked ~ .tab-panels > .tab-panel:nth-child(6) {
    display: block;
}

/*
 Styling
*/
body {
    font: 16px/1.5em "Overpass", "Open Sans", Helvetica, sans-serif;
    color: #333;
    font-weight: 300;
}

.ba-box-tabs {
  display: block !important;
}

.tabset > input:checked + label {
color: #0072E1;
background-color: transparent;
border-top: 1.5px solid #0072E1;
border-radius: 0;
font-weight: 600;
}

label {
margin-bottom: 0;
}

.text-green {
color: #0cad25;
}
.text-red,
.text-red span{
color: red !important;
}
.table__scroll {
overflow-x: auto;
table {

    thead tr th {
        color: var(--theme-color-primary);
        font-size: 0.9rem;
        text-align: center;
        padding: 1.5rem 0;
        //border-right: 1px solid #e7eaec;
        &:last-child {
            border-right: none;
        }
    }
    tbody tr td,
    tbody tr td div,
    tbody tr td span {
        font-size: 0.88rem;
        text-align: center;
    }
    tbody tr td {
        //border-right: 1px solid #e7eaec;
        vertical-align: middle;
        &:last-child {
            border-right: none;
        }
        &:not(:last-child):after{
          content: "";
          position: absolute;
          top: 25%;
          right: 0;
          height: 50%;
          border-right: 1px solid #B4C4D7;
        }
    }
    .span__title {
        color: var(--theme-color-primary);
        font-size: 0.88rem;
        font-weight: bold;
    }
}
}
.values {
display: inline-block;
float: right;
background: white;
padding: 1rem 1rem 1rem 10rem;
box-shadow: 0 0 30px -5px #edeff2;
border-radius: 7px;
.value__only {
    color: #0cad25;
    span {
        font-size: 1.3rem;
        font-weight: bold;
        &:last-child {
            font-size: 3rem;
            margin-left: 1rem;
        }
    }
}
}
.bottom-paginator {
width: 100%;
display: flex;
align-items: center;
justify-content: center;
gap: 1rem;

.paginator-button {
width: 6rem;
height: 2rem;
}
}
.ba-hr-row {
  margin: 12px 0 !important;
}
</style>



// WEBPACK FOOTER //
// resources/office/js/components/franchise_v4/rank/components/gainsFranchiseeBa.vue